import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useAppSelector } from '../../redux/app/hooks';
import { RootState } from '../../redux/app/store';
import { useUserPreferences } from './useUserPreferences';

export const useInitialUserPreferences = () => {
    const auth = useAuth();
    const { fetchPreferences } = useUserPreferences();
    const responseStylePreferenceEnabled = useAppSelector(
        (state: RootState) => state.app.serviceInfo.featureFlags.ResponseStylePreferenceEnabled,
    );

    useEffect(() => {
        if (auth.isAuthenticated && responseStylePreferenceEnabled) {
            void fetchPreferences();
        }
    }, [auth.isAuthenticated, responseStylePreferenceEnabled, fetchPreferences]);
};
